// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__r9YmC","iconTooltip":"styles_iconTooltip__Ed0LG","required":"styles_required__Egf7K"};